<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        現場編集 - {{name}}
        <div class="headerBtn" @click="screenTransition(siteslistPath)" style="margin: 0px 0px 0px 20px;">
          一覧に戻る
        </div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <form v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              建設キャリアアップシステム登録情報
            </div>
            <div class="row">
              <p class="inputTitle editable">現場ID</p>
              <div v-if="role === 'admin'">
              <validation-provider name="現場ID" rules="digits:14" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" :placeholder="before.ccusId" v-model="detail.ccusId">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
              <div v-if="role === 'business' || role === 'branch'">
                <div class="rowRight">
                  <input class="text large" :placeholder="before.ccusId"
                  v-model="detail.ccusId" readonly>
                </div>
              </div>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              基本情報【必須】
            </div>
            <div class="row">
              <p class="inputTitle editable">現場名</p>
              <validation-provider name="現場名" rules="required|min:2|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                <input class="text large" :placeholder="before.siteName" v-model="detail.siteName" @change="log(before, detail)" >
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">工期（開始）</p>
              <validation-provider name="工期（開始）" rules="required" vid="startDate" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" type="date" max='9999-12-31' v-model="detail.startDate">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">工期（終了）</p>
              <validation-provider name="工期（終了）" rules="required|periodValidity:startDate" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" type="date" max='9999-12-31' v-model="detail.endDate">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              住所【必須】
            </div>
            <div class="row">
              <p class="inputTitle editable">郵便番号</p>
              <validation-provider name="郵便番号" rules="required|digits:7|addressFlg" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" @change="getAddress(detail)" class="text large" placeholder="例：1000001 ハイフン無し半角数字のみ入力"
                  name="postalCode" v-model="detail.postalCode"
          />
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan" v-if="postalHasError">
                      {{ ProviderProps.errors[0] }}
                    </span>
                    <span class="prefectureErrSpan" v-if="!postalHasError">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">都道府県</p>
              <validation-provider name="都道府県" rules="required||max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.prefecture" :placeholder="'例：東京都'">
                    <div class="errMsg" v-if="ProviderProps.errors[0]">
                      <span class="errSpan">
                        {{ ProviderProps.errors[0] }}
                      </span>
                    </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">市区町村</p>
              <validation-provider name="市区町村" rules="required|max:255" mode="lazy">
              <div class="rowRight" slot-scope="ProviderProps">
                <input type="text" class="text large" name="city"
                 v-model="detail.city" :placeholder="'例：千代田区'"/>
                 <div class="errMsg" v-if="ProviderProps.errors[0]">
                   <span class="errSpan">
                     {{ ProviderProps.errors[0] }}
                   </span>
                 </div>
               </div>
             </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">町・番地</p>
              <validation-provider name="町・番地" rules="required|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" :placeholder="'例：丸の内1-1'" v-model="detail.town">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">建物名/部屋番号</p>
              <validation-provider name="建物名/部屋番号" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" :placeholder="'例：千代田ビル2F'" v-model="detail.otherAddress">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              現場管理者【任意】
            </div>
            <div class="row">
              <p class="inputTitle editable">現場管理者</p>
              <validation-provider name="現場管理者" rules="max:255" mode="lazy">
                <div class="selectdiv">
                  <select  v-model="detail.supervisorId" @change="updateSiteTel(optionWorkers,detail.ccusIdsupervisorId)">
                    <option value="" selected>現場管理者を選択</option>
                    <option v-for="worker in optionWorkers"
                      v-bind:value="worker.workerId">
                      {{ worker.workerName }}
                    </option>
                  </select>
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="group" v-if="role === 'admin'">
            <div class="groupTitle" style="display: flex;">
              連携設定
            </div>
            <div class="row">
              <p class="inputTitle editable">Face-DB Serverとの連携対象とする</p>
              <div class="switch switch__apartRow">
                <label class="switch__label">
                  <input type="checkbox" class="switch__input" v-model="detail.syncFlg" true-value="1" false-value="0" />
                  <span class="switch__content"></span>
                  <span class="switch__circle"></span>
                </label>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">処理状況</p>
              <div class="rowRight">
                <input type="text" class="text large" name="constructionSystemSyncStatus"
                v-model="constructionSystemSyncStatus" readonly/>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable"></p>
            </div>
          </div>
          <!-- <div class="group">
            <div class="groupTitle" style="display: flex;">
              入退場承認
            </div>
            <div class="row">
              <p class="inputTitle editable">自動承認</p>
              <div class="switch">
                <label class="switch__label">
                  <input type="checkbox" class="switch__input" checked="checked" v-model="detail.approve" />
                  <span class="switch__content"></span>
                  <span class="switch__circle"></span>
                </label>
              </div>
            </div>
          </div> -->
            <!-- ローディング -->
            <div v-if="postLodingFlg">
              <vue-loading
                type="cylon"
                color="#1b7e47"
                :size="{ width: '150px', height: '150px' }"
              >
              </vue-loading>
              <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
            </div>
            <!-- 処理状況取得エラー -->
            <div v-if="syncStatusFailedMessage" style="padding: 0px 0px 30px 0px; margin: auto;">
              <div class="errMsg">
                <div class="errDiv">
                  <div class="errSpan" style="font-size:x-large;">
                    {{ syncStatusFailedMessage }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 登録エラー表示 -->
            <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
              <div　class="errMsg">
                <div class="errDiv">
                  データの更新中に問題が発生しました。
                    <div class="errSpan" style="font-size:x-large;">
                      {{errorMessage}}
                    </div>
                </div>
              </div>
            </div>
            <!-- 入力チェックエラー表示 -->
            <div v-if="validationErrMsg.length > 0">
              <div　class="errMsg" v-for="error in validationErrMsg">
                <div class="errSpan">{{error}}</div>
              </div>
            </div>
            <!-- 登録ボタン -->
            <div class="buttonGroup">
            <button class="btn" type="button" @click="confirm" 
              v-bind:class="{ disabled: isProcessing() || !ObserverProps.validate 
              ||!isPostDisabled(ObserverProps,postalHasError)
              || detail.siteName === ''
              || detail.startDate === ''
              || detail.endDate === ''
              || detail.postalCode === ''
              || detail.prefecture === ''
              || detail.city === ''
              || detail.town === '',
              active: isPostDisabled(ObserverProps,postalHasError)
              && detail.siteName !== ''
              && detail.startDate !== ''
              && detail.endDate !== ''
              && detail.postalCode !== ''
              && detail.prefecture !== ''
              && detail.city !== ''
              && detail.town !== ''
              && ObserverProps.validate }"
              :disabled="!isPostDisabled(ObserverProps,postalHasError)
              || isProcessing() 
              || postLodingFlg 
              || detail.siteName === ''
              || detail.startDate === ''
              || detail.endDate === ''
              || detail.postalCode === ''
              || detail.prefecture === ''
              || detail.city === ''
              || detail.town === ''">変更
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';
import constants from "../constants/constants";

export default {
  title: '現場編集',
  name: 'SiteEdit',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  props: {
    id: {
      type: String,
      default: '',
      required: true,
    },
    name: {
      type: String,
      default: '',
      required: true,
    },
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      siteslistPath: '/sites', // 現場一覧パス
      // 更新用モデル
      detail: {
        ccusId: '',
        siteId: '',
        siteName: '',
        startDate: '',
        endDate: '',
        postalCode: '',
        prefecture: '',
        city: '',
        town: '',
        otherAddress: '',
        fullAddress: '',
        tel: '',
        supervisorId: '',
        approve: true,
        syncFlg: 0,
      },
      // プレースホルダー用元値
      before: {
        ccusId: '未設定',
        siteId: '未設定',
        siteName: '未設定',
        startDate: '00000000',
        endDate: '00000000',
        postalCode: '未設定',
        prefecture: '未設定',
        city: '未設定',
        town: '未設定',
        otherAddress: '未設定',
        fullAddress: '未設定',
        tel: '未設定',
        supervisorId: '未設定',
        approve: true,
      },
      // 施工体制連携の最新状況
      constructionSystemSyncStatus: '',
      // 施工体制連携ステータス取得失敗時のメッセージ
      syncStatusFailedMessage: '',
      // 選択用技能者配列
      optionWorkers: [],
      // ローディング
      getLodingFlg: true, // データ取得時ローディング用フラグ
      getErrorFlg: false, // データ取得時エラーフラグ
      postLodingFlg: false, // データ登録時ローディングフラグ
      postErrorFlg: false, // データ登録時エラーフラグ
      // 入力チェック
      validationErrFlg: false, // 入力チェックエラーフラグ
      processing: false,
      validationErrMsg: [], // 入力チェックエラーメッセージ用配列
      errorMessage: '',
      searchCondition: {},
      // 郵便番号エラー判定用フラグ
      postalHasError:true,

    };
  },
  created() {
   console.log(this.$route.params);
  },
  // 初期処理
  async mounted() {
    try {
      // 現場情報set
      await this.setSite(this.id, this.detail, this.before);
      // 施工体制連携の最新状況取得処理(運営管理者のみ)
      if (this.role === 'admin') {
        await this.getSyncConstructionStatus();
      }
      // await new Promise((resolve) => setTimeout(resolve, 300));
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 郵便番号を元に住所取得
    getAddress(detail) {
      const restResourceService = new ApiClient();
      restResourceService.getAddress(detail.postalCode)
        .then((res) => {
          if(res === 404){
            this.postalHasError = false;
            this.detail.prefecture = "";
            this.detail.city = "";
            this.detail.town = "";
            this.detail.fullAddress = "";
          } else{
            this.postalHasError = true;
            this.detail.prefecture = res.pref;
            this.detail.city = res.city;
            this.detail.town = res.town;
            this.detail.fullAddress = res.pref + res.city + res.town;
          }
        });
    },
    // 現場一意情報取得API呼出
    async setSite(id, detail, before) {
      try {
        const restResourceService = new ApiClient();
        await restResourceService.getSite(id)
        .then((res) => {
          detail.companyId = res.companyId;
          detail.branchId = res.branchId;
          detail.ccusId = res.ccusId;
          detail.siteId = res.siteId;
          detail.siteName = res.siteName;
          detail.startDate = common.dateFormatHyphen(res.startDate);
          detail.endDate = common.dateFormatHyphen(res.endDate);
          detail.postalCode = res.postalCode;
          detail.prefecture = res.prefecture;
          detail.city = res.city;
          detail.town = res.town;
          detail.otherAddress = res.otherAddress;
          detail.fullAddress = res.fullAddress;
          detail.tel = res.tel;
          detail.supervisorId = res.supervisorId;
          detail.syncFlg = res.syncFlg !== undefined && res.syncFlg !== null ? res.syncFlg : 0;
          // this.getAddress(detail);
          this.updateWorkersList(detail);
          // before
          before.companyId = res.companyId;
          before.branchId = res.branchId;
          before.ccusId = res.ccusId;
          before.siteId = res.siteId;
          before.siteName = res.siteName;
          before.startDate = common.dateFormatHyphen(res.startDate);
          before.endDate = common.dateFormatHyphen(res.endDate);
          before.postalCode = res.postalCode;
          before.prefecture = res.prefecture;
          before.city = res.city;
          before.town = res.town;
          before.otherAddress = res.otherAddress;
          before.fullAddress = res.fullAddress;
          before.tel = res.tel;
          before.supervisorId = res.supervisorId;
        });
        return;
      } catch (error) {
        this.errorMessage = error.message;
      throw error;
      }
    },
    // 技能者リスト取得API呼出し
    async updateWorkersList(detail) {
      try {
        this.searchCondition['companyId'] = detail.companyId;
        this.searchCondition['branchId'] = detail.branchId;
        const restResourceService = new ApiClient();
        // TODO: 取得人数
        const result =await restResourceService.getWorkersList(constants.LIMIT, constants.PAGE, this.searchCondition,{})
        this.optionWorkers = result.workers;
      } catch (error) {
        this.errorMessage = error.message;
      throw error;
      }
    },
    async updateSiteTel(optionWorkers, ccusIdsupervisorId) {
      try {
        const workers = await optionWorkers;
        await workers.forEach((worker) => {
          if (ccusIdsupervisorId === worker.workerId) {
            this.detail.tel = worker.tel;
            console.log(this.detail.tel);

          }
        });
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // 変更ボタン押下時 更新処理
    async confirm() {
      // ボタン非活性化
      this.startProcessing();
      // ====================入力項目空白削除====================
      this.detail.siteName = this.detail.siteName.trim();
      this.detail.town = this.detail.town.trim();
      if (this.detail.otherAddress) {
        this.detail.otherAddress = this.detail.otherAddress.trim();
      }
      if (this.detail.supervisorId) {
        this.detail.supervisorId = this.detail.supervisorId.trim();
      }
      // ====================入力チェック開始====================
      // 入力チェックフラグ・メッセージ初期化
      this.validationErrFlg = false;
      this.validationErrMsg = [];
      // 入力に不正がある場合、処理を中断
      if (this.validationErrFlg) {
        return;
      }
      // ====================入力チェック終了====================
      this.detail.siteId = this.before.siteId;
      if (this.detail.otherAddress) {
        this.detail.fullAddress = this.detail.prefecture + this.detail.city + this.detail.town + this.detail.otherAddress;
      } else {
        this.detail.fullAddress = this.detail.prefecture + this.detail.city + this.detail.town;
      }
      this.detail.startDate = common.unixTimeFormat(this.detail.startDate);
      this.detail.endDate = common.unixTimeFormat(this.detail.endDate);
      if(this.detail.prefecture === undefined)this.detail.prefecture = '';
      if(this.detail.city === undefined)this.detail.city = '';
      if(this.detail.town === undefined)this.detail.town = '';
      if(this.detail.fullAddress === undefined)this.detail.fullAddress = '';
      // ====================API呼出処理開始====================
      try {
        // フラグ初期化
        this.postErrorFlg = false;
        // ローディング表示
        this.postLodingFlg = true;

        // 現場更新API呼出
        const body = {
          siteId:  this.$route.params.id,
          ccusId:  this.detail.ccusId,
          siteName: this.detail.siteName,
          companyId: this.detail.companyId,
          branchId: this.detail.branchId,
          postalCode: this.detail.postalCode,
          prefecture: this.detail.prefecture,
          city: this.detail.city,
          town: this.detail.town,
          otherAddress: this.detail.otherAddress,
          fullAddress: this.detail.fullAddress,
          tel: this.detail.tel,
          supervisorId: this.detail.supervisorId,
          startDate: this.detail.startDate,
          endDate: this.detail.endDate,
          syncFlg: this.detail.syncFlg !== undefined && this.detail.syncFlg !== null ? Number(this.detail.syncFlg) : 0,
        };
        const restResourceService = new ApiClient();
        await restResourceService.putSite(body);
        this.screenTransition(this.siteslistPath);
      } catch (error) {
        if(error.errorCode === 'EM009'){
          this.errorMessage = 'CCUS現場IDが既に他の現場で使用されています。'
        }else{
          this.errorMessage = error.message;
        }
        this.postErrorFlg = true;
        this.endProcessing();
      } finally {
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    // 施工体制取得/連携の最新処理状況取得処理
    async getSyncConstructionStatus() {
      try {
        const restResourceService = new ApiClient();
        const result = await restResourceService.getSyncConstructionStatus(
          this.id
        );

        // 成功した場合、レスポンスで返却される連携ステータスを反映
        this.syncStatusFailedMessage = '';
        this.constructionSystemSyncStatus = result.process?.sync?.statusName ?? '未連携';
      } catch (error) {
        console.warn('getSyncConstructionStatus failed:', error);
        this.syncStatusFailedMessage =
          '処理状況の取得に失敗しました。画面をリロードしてください。';
        this.constructionSystemSyncStatus = '未連携';
      }
    },


    // 画面遷移
    screenTransition(path) {
      history.back();
    },
    log(before, detail) {
      console.log('before: ', before.siteName);
      console.log('detail: ', detail.siteName);
    },
     // 更新ボタン判定用
    isPostDisabled(item,isError){
      return common.isPostalValidate(item,isError,5)
    },
    // チャタリング防止
    startProcessing() {
      this.processing = true;
    },
    endProcessing() {
      this.processing = false;
    },
    isProcessing() {
      return this.processing;
    },
  },
  filters: {
    filterZip(d) {
      const buf = ('0000000' + d).slice(-7);
      return buf;
      // return isNaN(buf) ? '1000000' : buf;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";

/*** iOS ***/
.switch__apartRow {
  margin-left: 10px;
}
.switch__label {
	width: 100px;
	position: relative;
	display: inline-block;
  margin-top: 13px;
}
.switch__content {
	display: block;
  cursor: pointer;
  position: relative;
  border-radius: 30px;
  height: 31px;
overflow: hidden;
}
.switch__content:before {
	content: "";
	display: block;
	position: absolute;
	width: calc(100% - 3px);
	height: calc(100% - 3px);
	top: 0;
	left: 0;
	border: 1.5px solid #E5E5EA;
	border-radius: 130px;
	background-color: #fff;
}
.switch__content:after {
	content: "";
	display: block;
	position: absolute;
	background-color: transparent;
	width: 0;
	height: 0;
	top: 50%;
	left: 50%;
	border-radius: 30px;
	-webkit-transition: all .5s;
	   -moz-transition: all .5s;
	    -ms-transition: all .5s;
	     -o-transition: all .5s;
	        transition: all .5s;
}
.switch__input {
	display: none;
}

.switch__circle {
	display: block;
	top: 2px;
	left: 2px;
	position: absolute;
	-webkit-box-shadow: 0 2px 6px #999;
	        box-shadow: 0 2px 6px #999;
	width: 27px;
	height: 27px;
	-webkit-border-radius: 20px;
	        border-radius: 20px;
	background-color: #fff;
	-webkit-transition: all .5s;
	   -moz-transition: all .5s;
	    -ms-transition: all .5s;
	     -o-transition: all .5s;
	        transition: all .5s;
}
.switch__input:checked ~ .switch__circle {
	left: 71px;
}

.switch__input:checked ~ .switch__content:after {
	background-color: #4BD964;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.selectdiv {
  position: relative;
  float: left;
  min-width: 494px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 14.5px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}
</style>
